let searchBtn = document.getElementById('top-search-btn');
let searchBtnMobile = document.getElementById('top-search-btn-mobile');
let searchCloseBtn = document.getElementById('top-search-close');
let searchContent = document.getElementById('top-search');

searchBtn.addEventListener('click', event => {
    searchContent.classList.add('active');
})

searchBtnMobile.addEventListener('click', event => {
    searchContent.classList.add('active');
})

searchCloseBtn.addEventListener('click', e => {
    searchContent.classList.remove('active');
})